.info {
  padding: var(--spacing) calc(var(--spacing) * 2);
  color: var(--color-black-50);
  font-size: 13px;

  & > a {
    color: var(--color-black-50);
  }
}

.instructions {
  color: var(--color-black-50);
  font-size: 13px;
}

.message {
  padding: calc(var(--spacing) * 2);
}

.buttonWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: var(--spacing) calc(var(--spacing) * 2) calc(var(--spacing) * 2);
  border-radius: var(--border-radius);
  background: var(--color-cool-gray);
}

.button {
  width: 100%;
  height: 42px;
  padding: 0 16px;
  color: black;
  background: var(--color-yellow);
  border-radius: var(--border-radius);
  transition: background-color 0.4s;

  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  /* line-height: 1.1em; */

  &:focus-visible {
    background: var(--color-black-20);
  }

  &:focus-visible {
    background: var(--color-dark-yellow);
  }

  @media (--hover) {
    &:hover {
      background: var(--color-dark-yellow);
    }
  }

  &:disabled {
    color: var(--color-black-20);
  }
}
